import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';

import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { PageAccessResponse } from './auth-exchange.model';
import { ACCESS_TOKEN_KEY, AUTH_PAGE_ACCESS_PATH } from './auth.constants';

@Injectable({
  providedIn: 'root'
})
export class PageAccessService {
  readonly #httpClient = inject(HttpClient);
  readonly #baseUrl = `${environment.urlProfileManagement}${AUTH_PAGE_ACCESS_PATH}`;

  check(path: string): Observable<boolean> {
    if (!localStorage.getItem(ACCESS_TOKEN_KEY)) {
      return of(false);
    }

    const params = new HttpParams().set('path', path);

    return this.#httpClient.get<PageAccessResponse>(this.#baseUrl, { params }).pipe(
      map((response) => response.allowed),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          return throwError(() => error);
        }

        return of(false);
      })
    );
  }
}
